import React from "react";
import tw from "twin.macro";
import LineChart from "../charts/LineChart";
import purchasing from "../../data/purchasing";
import processOptimizationLogistic from "../../data/processOptimizationLogistic";
import processOptimizationICT from "../../data/processOptimizationICT";




const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`md:w-6/12 flex-shrink-0 relative`;

const purchasingData = {
    label: "",
    data: purchasing,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

const processOptimizationLogisticData = {
    label: "",
    data: processOptimizationLogistic,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

const processOptimizationICTData = {
    label: "",
    data: processOptimizationICT,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

export default ({
                    title = "",
                    d1 = "",
                    d2 = "",
                    d3 = "",
                    ex1="",
                    ex2="",
                }) => {
    return (
        <>
            <h1>{title}</h1>
            <p>
                {d1}
            </p>
            <h6><strong>{ex1}</strong></h6>
            <div  style={{textAlign:'center',margin:'3% 0% 3% 0%'}}>
                <ImageColumn style={{marginLeft:'auto',marginRight:'auto'}}>
                    <LineChart
                        data={[purchasingData]}
                        title="Purchasing - Sourcing - Sales"
                        legend={false}
                        dateFormat="month"
                    />
                </ImageColumn>
            </div>
            <p>
                {d2}
            </p>
            <h6><strong>{ex2}</strong></h6>
            <div  style={{textAlign:'center',margin:'3% 0% 3% 0%'}}>
                <ImageColumn style={{marginLeft:'auto',marginRight:'auto'}}>
                    <LineChart
                        data={[processOptimizationLogisticData]}
                        title="Process optimization - logistics"
                        legend={false}
                        dateFormat="month"
                    />
                    <LineChart
                        data={[processOptimizationICTData]}
                        title="Process optimization - ICT"
                        legend={false}
                        dateFormat="month"
                    />
                </ImageColumn>
            </div>
            <p>
                {d3}
            </p>
        </>
    );
};
